module.exports = __webpack_public_path__ + "media/brand/dots-blue-8fc07a5a.svg";